import axios from 'axios';
import { baseURL } from '../utility/Constants';

/**
 * @typedef {Object} ChargeCycleMetricsResponse
 * @property {string} emsName
 * @property {string} timeFilter
 * @property {string} startDate
 * @property {string} endDate
 * @property {Array<{
 *   timestamp: number,
 *   cycle: number,
 *   ah_partial: number,
 *   data_points?: number,
 *   hour_timestamp?: number
 * }>} data
 */

/**
 * Fetches charge cycle metrics data
 * @param {string} emsName - The EMS name
 * @param {'daily' | 'weekly' | 'monthly'} timeFilter - Time filter for the data
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {Promise<ChargeCycleMetricsResponse>}
 */
export const fetchChargeCycleMetrics = async (emsName, timeFilter, date) => {
  try {
    const response = await axios.post(`${baseURL}/charge-cycle-metrics`, {
    emsName,
    timeFilter,
    date
    });
   
    return response.data;
  } catch (error) {
    console.error('Error fetching charge cycle metrics:', error);
    throw error;
  }
};
